var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal_content login_extension_wrap" }, [
      _c("div", { staticClass: "modal_header" }, [
        _c("h5", { staticStyle: { color: "red" } }, [
          _vm._v(_vm._s(_vm.$t("cop.pm.title")))
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_body" }, [
        _c("div", { staticClass: "extension_wrap" }, [
          _c("div", { staticClass: "time" }, [
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.remainMin))]),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("cop.login-extension.minute")))
              ]),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.remainSec))]),
              _c("span", [_vm._v(_vm._s(_vm.$t("cop.login-extension.second")))])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("cop.pm.message.progress-bar")) +
                  "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ext_prog" }, [
            _c("span", { style: { width: 100 - _vm.remainTime / 6000 + "%" } })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "ext_msg",
            domProps: {
              innerHTML: _vm._s(_vm.$t("cop.pm.message.information"))
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.confirm")) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17f5a668", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f5a668","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup/MaintenanceAlertPopup.vue
// module id = null
// module chunks = 